<template>
  <div class="tuYaPage">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80:50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column
        prop="customerId"
        label="客户"
        min-width="130px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productId"
        label="产品型号"
        min-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.product">{{scope.row.product.name}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="defaultPid"
        label="默认PID"
        min-width="130px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.defaultPid">{{scope.row.defaultPid}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tuyaPid"
        label="自定义PID"
        min-width="130px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.tuyaPid">{{scope.row.tuyaPid}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sales"
        label="业务员"
        min-width="80px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.sales">{{scope.row.sales}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productName"
        label="注册名称"
        min-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.productName">{{scope.row.productName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="master"
        label="所属开发者"
        min-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.master">{{scope.row.master}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="notes" label="备注" min-width="110px" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.notes">{{scope.row.notes}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="95px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
            <i @click="editTuYaPid($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getCustomerPidSearch"
    ></pagination>
    <myDialog
      ref="tuYaDialog"
      :title="tuYaDialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="tuYaDialogForm"
          :model="tuYaDialogForm"
          :rules="tuYaDialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="客户：" size="small" prop="customerId">
            <el-select
              v-model="tuYaDialogForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号：" size="small" prop="productId">
            <el-select v-model="tuYaDialogForm.productId" placeholder="选择产品型号" filterable clearable>
              <el-option
                v-for="(item, index) in $parent.pullDownData.tuYaProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="PID：" size="small" prop="tuyaPid">
            <el-input v-model="tuYaDialogForm.tuyaPid" placeholder="客户所申请的涂鸦PID" clearable></el-input>
          </el-form-item>
          <el-form-item label="业务员：" size="small" prop="sales">
            <el-input v-model="tuYaDialogForm.sales" placeholder="如：张三" clearable></el-input>
          </el-form-item>
          <el-form-item label="注册名称：" size="small">
            <el-input v-model="tuYaDialogForm.productName" placeholder="涂鸦IoT平台注册的名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="开发者：" size="small">
            <el-input v-model="tuYaDialogForm.master" placeholder="涂鸦IoT平台归属的帐号" clearable></el-input>
          </el-form-item>
          <el-form-item label="备注：" size="small" prop="notes">
            <el-input
              type="textarea"
              :rows="2"
              v-model="tuYaDialogForm.notes"
              placeholder="如：已迁移到客户帐号"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiCustomerPidSearch,
  apiCustomerPidExport,
  apiCustomerPidAdd,
  apiCustomerPidUpdate
} from "@/api/customerManage.js";

export default {
  components: {
    pagination,
    myDialog
  },
  props: {
    tuYaSearchForm: {
      type: Object
    }
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      tuYaDialogTitle: "",
      tuYaDialogForm: {},
      tuYaDialogRules: {
        customerId: [
          { required: true, message: "客户名称不能为空！", trigger: "change" }
        ],
        productId: [
          { required: true, message: "产品型号不能为空！", trigger: "change" }
        ],
        tuyaPid: [
          { required: true, message: "涂鸦PID不能为空！", trigger: "blur" },
          {
            min: 16,
            max: 64,
            message: "长度在 16 到 64 个字符",
            trigger: "blur"
          }
        ],
        sales: [
          { required: true, message: "业务员姓名不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "blur"
          }
        ]
      },
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    // 表格数据
    async getCustomerPidSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiCustomerPidSearch({
        ...this.tuYaSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getCustomerPidSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getCustomerPidSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getCustomerPidSearch();
    },
    // 导出涂鸦PID
    exportTuYaPid() {
      this.$confirm("确定导出涂鸦PID明细吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiCustomerPidExport();
        if (res.code == 0) {
          let a = document.createElement("a");
          a.download = res.fileName;
          a.href = res.uri;
          a.style.display = "none";
          a.target = "_blank";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      });
    },
    // 添加涂鸦PID
    addTuYaPid() {
      this.tuYaDialogTitle = "添加涂鸦PID";
      this.$refs.tuYaDialog.dialogVisible = true;
    },
    // 修改涂鸦PID
    editTuYaPid(e, row) {
      e.target.blur();
      this.tuYaDialogTitle = "修改涂鸦PID";
      this.$refs.tuYaDialog.dialogVisible = true;
      this.tuYaDialogForm = {
        ...row,
        customerId: row.customer.id,
        productId: row.product.id,
        customer: undefined,
        product: undefined
      };
    },
    // 确认添加
    submitData(title) {
      this.$refs.tuYaDialogForm.validate(async valid => {
        if (valid) {
          let res = {};
          if (title == "添加涂鸦PID") {
            res = await apiCustomerPidAdd({
              ...this.tuYaDialogForm
            });
            if (res.code == 0) {
              this.$refs.tuYaDialog.dialogVisible = false;
              this.getCustomerPidSearch();
              this.$message({
                type: "success",
                message: "添加成功"
              });
            }
          } else if (title == "修改涂鸦PID") {
            res = await apiCustomerPidUpdate({
              ...this.tuYaDialogForm
            });
            if (res.code == 0) {
              this.$refs.tuYaDialog.dialogVisible = false;
              this.getCustomerPidSearch("noRemove");
              this.$message({
                type: "success",
                message: "修改成功"
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.tuYaDialogForm.resetFields();
      this.tuYaDialogForm = {};
    }
  }
};
</script>

<style lang="less" scope>
.tuYaPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>